 <svg
        class="animated-svg"
        [attr.viewBox]="'0 0 ' + width() + ' ' + (height() + 120)"
        preserveAspectRatio="xMidYMin meet">
        
        <g wall-type-2 [height]="height()"></g>
        
        <g roof-type-4/>
        <g outline />
        <g window-type-8 [height]="height()"/>

</svg>